import contractorSiteDeliveryCard from '@assets/eDocuments/contractorSiteDeliveryCard.webp'
import detailsOfOverheadLines from '@assets/eDocuments/detailsOfOverheadLines.webp'
import excavationAndCableLayingWork from '@assets/eDocuments/excavationAndCableLayingWork.webp'
import listOHInspection from '@assets/eDocuments/listOHInspection.webp'
import measurementSheet from '@assets/eDocuments/measurementSheet.webp'
import measurementsSheetForMeters from '@assets/eDocuments/measurementsSheetForMeters.webp'
import measurementsSheetForOHNetwork from '@assets/eDocuments/measurementsSheetForOHNetwork.webp'
import minipillar from '@assets/eDocuments/minipillar.webp'
import overheadLineAsBuiltReportSummary from '@assets/eDocuments/overheadLineAsBuiltReportSummary.webp'
import procedure190 from '@assets/eDocuments/procedure190.webp'
import siteSurveyForm from '@assets/eDocuments/siteSurveyForm.webp'
import splicingTermination from '@assets/eDocuments/splicingTermination.webp'
import starsSafety from '@assets/eDocuments/starsSafety.webp'
import substationAndElectricalEquipmentInspection from '@assets/eDocuments/substationAndElectricalEquipmentInspection.webp'
import substationEarthing from '@assets/eDocuments/substationEarthing.webp'
import substationFoundation from '@assets/eDocuments/substationFoundation.webp'
import workSiteInspectionForm from '@assets/eDocuments/workSiteInspectionForm.webp'

/*
fields: {type, x, y, w, h, default, fontSize, readonly}

- t   : textfield            -> value: string
- ta  : textarea              -> value: string
- yn  : yes / no               -> value: 'yes' | 'no'
- yna : yes / no / n/a         -> value: 'yes' | 'no' | 'na'
- i   : image (upload/preview) -> value: { file: File, url: string }
*/
export const docs = ({
    contractor,
    user,
    user_signature,
    supervisor_signature,
}) => {
    return [
        {
            text: 'بطاقة تسليم الموقع للمقاول',
            image: contractorSiteDeliveryCard,
            fields: [
                {type: 't', x: 950, y: 175, w: 95, h: 45},
                {type: 't', x: 200, y: 175, w: 245, h: 45},

                {type: 't', x: 890, y: 235, w: 135, h: 80},
                {type: 't', x: 550, y: 235, w: 205, h: 80},
                {type: 't', x: 150, y: 235, w: 235, h: 80, default: contractor},

                {type: 't', x: 660, y: 325, w: 200, h: 55},
                {type: 't', x: 150, y: 325, w: 320, h: 55},

                {type: 't', x: 660, y: 400, w: 200, h: 55},
                {type: 't', x: 150, y: 400, w: 300, h: 55},


                {type: 't', x: 920, y: 600, w: 226, h: 45, default: 'some default val'},
                {type: 't', x: 350, y: 600, w: 565, h: 45},
                {type: 't', x: 240, y: 600, w: 105, h: 45},
                {type: 't', x: 140, y: 600, w: 95, h: 45},

                {type: 't', x: 920, y: 650, w: 226, h: 45},
                {type: 't', x: 350, y: 650, w: 565, h: 45},
                {type: 't', x: 240, y: 650, w: 105, h: 45},
                {type: 't', x: 140, y: 650, w: 95, h: 45},

                {type: 't', x: 920, y: 702, w: 226, h: 45},
                {type: 't', x: 350, y: 702, w: 565, h: 45},
                {type: 't', x: 240, y: 702, w: 105, h: 45},
                {type: 't', x: 140, y: 702, w: 95, h: 45},

                {type: 't', x: 920, y: 754, w: 226, h: 45},
                {type: 't', x: 350, y: 754, w: 565, h: 45},
                {type: 't', x: 240, y: 754, w: 105, h: 45},
                {type: 't', x: 140, y: 754, w: 95, h: 45},

                {type: 't', x: 920, y: 804, w: 226, h: 45},
                {type: 't', x: 350, y: 804, w: 565, h: 45},
                {type: 't', x: 240, y: 804, w: 105, h: 45},
                {type: 't', x: 140, y: 804, w: 95, h: 45},

                {type: 't', x: 920, y: 856, w: 226, h: 45},
                {type: 't', x: 350, y: 856, w: 565, h: 45},
                {type: 't', x: 240, y: 856, w: 105, h: 45},
                {type: 't', x: 140, y: 856, w: 95, h: 45},

                {type: 't', x: 920, y: 908, w: 226, h: 45},
                {type: 't', x: 350, y: 908, w: 565, h: 45},
                {type: 't', x: 240, y: 908, w: 105, h: 45},
                {type: 't', x: 140, y: 908, w: 95, h: 45},

                {type: 't', x: 920, y: 959, w: 226, h: 45},
                {type: 't', x: 350, y: 959, w: 565, h: 45},
                {type: 't', x: 240, y: 959, w: 105, h: 45},
                {type: 't', x: 140, y: 959, w: 95, h: 45},

                {type: 't', x: 920, y: 1011, w: 226, h: 45},
                {type: 't', x: 350, y: 1011, w: 565, h: 45},
                {type: 't', x: 240, y: 1011, w: 105, h: 45},
                {type: 't', x: 140, y: 1011, w: 95, h: 45},

                {type: 't', x: 920, y: 1063, w: 226, h: 45},
                {type: 't', x: 350, y: 1063, w: 565, h: 45},
                {type: 't', x: 240, y: 1063, w: 105, h: 45},
                {type: 't', x: 140, y: 1063, w: 95, h: 45},

                {type: 't', x: 920, y: 1114, w: 226, h: 45},
                {type: 't', x: 350, y: 1114, w: 565, h: 45},
                {type: 't', x: 240, y: 1114, w: 105, h: 45},
                {type: 't', x: 140, y: 1114, w: 95, h: 45},

                {type: 'i', x: 275, y: 1275, w: 250, h: 65, default: user_signature, readonly: true},
                {type: 'i', x: 275, y: 1350, w: 250, h: 65, default: supervisor_signature, readonly: true},
            ]
        },
        {
            text: 'نموذج فحص تفصيلي للخطوط الهوائية (المنفذة)',
            image: detailsOfOverheadLines
        },
        {
            text: 'أعمال الحفر وتمديدات الكوابل',
            image: excavationAndCableLayingWork
        },
        {
            text: 'نموذج فحص الأعمال الهوائية',
            image: listOHInspection
        },
        {
            text: 'نموذج القياس',
            image: measurementSheet
        },
        {
            text: 'صحيفة قياس للعدادات',
            image: measurementsSheetForMeters
        },
        {
            text: 'صحيفة قياس للشبكة الهوائية',
            image: measurementsSheetForOHNetwork
        },
        {
            text: 'لوحة التوزيع',
            image: minipillar
        },
        {
            text: 'تقرير ملخص تنفيذ الخط الهوائي',
            image: overheadLineAsBuiltReportSummary
        },
        {
            text: 'إجراء رقم (١٩٠)',
            image: procedure190
        },
        {
            text: 'نموذج مسح موقع',
            image: siteSurveyForm
        },
        {
            text: 'وصلات لحام / وصلات نهاية',
            image: splicingTermination
        },
        {
            text: 'نظام ادارة السلامة والصحة المهنية',
            image: starsSafety
        },
        {
            text: 'فحص محطة التوزيع والمعدات الكهربائية',
            image: substationAndElectricalEquipmentInspection
        },
        {
            text: 'تأريض المحطات',
            image: substationEarthing
        },
        {
            text: 'قواعد المحطات',
            image: substationFoundation
        },
        {
            text: 'نموذج التفتيش على موقع العمل',
            image: workSiteInspectionForm
        },
    ]
}